module.exports = __webpack_public_path__ + "static/media/baseball-umpire.0a5a1173.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/baseball-umpire.png
// module id = 829
// module chunks = 0